import React from "react";
import SelectedRadioButton from '@/assets/icons/SelectedRadioBtn.svg'
import UnSelectedRadioButton from '@/assets/icons/UnSelectedRadioButton.svg'
import DisabaledRadioBtn from '@/assets/icons/DisabledRadioBtn.svg'


interface RadioButtonProps {
  disabled?: boolean;
  value?: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
}
const RadioButton = ({
  value,
  disabled,
  checked,
  onChange,
  name,
}: RadioButtonProps) => {
  return (
    <label className={`relative ${disabled && "opacity-50"} block `}>
      <input
        disabled={disabled}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className="hidden"
      />
    
     {
      disabled ? <DisabaledRadioBtn/>:  checked ? <SelectedRadioButton/>:<UnSelectedRadioButton/>

     }
    
     
    
    </label>
  );
};

export default RadioButton;
